import { Component, OnInit, Input } from "@angular/core";
import { BasicaAnthropometricReport, ComparativeReport } from "@api/reports";

@Component({
  selector: "diameter-measurement",
  templateUrl: "./diameter-measurement.component.html",
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class DiameterMeasurementComponent implements OnInit {
  @Input() data: BasicaAnthropometricReport;
  @Input() dataComparative: ComparativeReport;
  public isReduced: boolean = false;
  public lastCol;
  public fontSize;

  constructor() {}

  ngOnInit() {
    const actualData = this.data ? this.data : this.dataComparative;
    this.isReduced = actualData.evaluationType === "REDUCED" ? true : false;
    this.lastCol = {
      "padding-right": "1rem;",
      "font-size": this.isReduced ? "14px" : "11px",
      padding: this.isReduced ? "4px" : "",
    };
    this.fontSize = {
      "font-size": this.isReduced ? "14px" : "11px",
      padding: this.isReduced ? "4px" : "",
    };
  }
  get current() {
    return this.data
      ? this.data.currentEvaluation.diameterMeasurement
      : this.dataComparative.selectedEvaluation1.diameterMeasurement;
  }
  get diff() {
    return this.data
      ? this.data.differenceWithPreviousEvaluation.diameterMeasurement
      : this.dataComparative.selectedEvaluation2.diameterMeasurement;
  }
  get score() {
    return this.data
      ? this.data.scoreZValues.diameterMeasurement
      : this.dataComparative.diferenceBetween.diameterMeasurement;
  }

  getPropArray(prop: string) {
    if (this.current && this.diff && this.score) {
      return [
        {
          data: this.current[prop],
          type: "height",
          style: this.fontSize,
        },
        {
          data: this.diff[prop],
          type: "height",
          style: this.fontSize,
        },
        {
          data: this.score[prop],
          type: "score",
          style: this.lastCol,
        },
      ];
    }
  }
}
